import React, { useEffect, useState } from "react";
import Pagination from "../commons/Pagination";
import { baseAxios } from "../../apis";
import moment from "moment";
import SkeletonCard from "../skeletons/SkeletonCard";
import { useBotDemo } from "../../context/botDemoContext";

export const LogBot = () => {
  const { selectedBot } = useBotDemo();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tradeLogs, setTradeLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedBot) {
      (async function () {
        setLoading(true);
        try {
          const { data } = await baseAxios.get(`/api/demo/bot_log`, {
            params: {
              bot_id: selectedBot?.id,
              page: page,
              limit: limit,
            },
          });
          setTotalPages(data?.total_pages);
          setTradeLogs(data?.logs);
        } catch (err) {
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [page, limit, selectedBot]);

  return (
    <div className="rounded-xl">
      <div className="flex justify-between items-center mb-3">
        {/* <select
          value={viewCount}
          onChange={(e) => changeViewCount(Number(e.target.value))}
          className="text-sm text-[#344054] border border-[#d0d5dd] rounded-md px-2 py-1 bg-white w-[100px]"
        >
          {[5, 10, 15, 20].map((count) => (
            <option key={count} value={count}>
              View {count}
            </option>
          ))}
        </select> */}
        <div className="relative z-[11] hidden md:flex items-center bg-white text-[#697077] text-sm px-5 pr-3 rounded-lg ml-auto">
          <span className="mr-2">View</span>
          <select
            name="view-table"
            id="view-table"
            className="border-none cursor-pointer outline-none m-0 text-sm py-1.5"
            onChange={(e) => setLimit(e.target.value)}
            value={limit}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
          </select>
        </div>
      </div>
      <div className="rounded-xl border w-full overflow-x-auto">
        <table className="w-full text-sm text-left text-[#344054]">
          <thead className="text-sm bg-[#F2F4F8] font-medium text-[#667085] border-b border-[#eaecf0]">
            <tr>
              <th className="p-4 rounded-tl-xl">ID.</th>
              <th className="p-4">Coin ID</th>
              <th className="p-4">Status</th>
              <th className="p-4">Message</th>
              {/* <th className="p-4">Created At</th> */}
              <th className="p-4 rounded-tr-xl">Updated At</th>
            </tr>
          </thead>
          <tbody className="text-sm text-[#101828]">
            {loading ? (
              [...Array(5)].map((_, idx) => (
                <tr key={idx} className="border-b border-[#f2f4f7] bg-white">
                  <td className={`p-4 text-sm ${4 === idx && "rounded-bl-xl"}`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className={`p-4 text-sm font-medium`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["200px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className={`p-4 text-sm ${4 === idx && "rounded-br-xl"}`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                </tr>
              ))
            ) : tradeLogs?.length ? (
              tradeLogs.map((item, idx) => (
                <tr
                  key={item.id}
                  className="border-b border-[#f2f4f7] bg-white"
                >
                  <td
                    className={`p-4 text-sm ${
                      tradeLogs?.length - 1 === idx && "rounded-bl-xl"
                    }`}
                  >
                    {item.id}
                  </td>
                  <td className="p-4 text-sm">{item.coin_name}</td>
                  <td className="p-4 text-sm">{item.status}</td>
                  <td className="p-4 text-sm">{item.message}</td>
                  <td className="p-4 text-sm">
                    {moment(item.created_at).format("DD/MM/YYYY HH:mm")}
                  </td>
                  <td
                    className={`p-4 text-sm ${
                      tradeLogs?.length - 1 === idx && "rounded-br-xl"
                    }`}
                  >
                    {moment(item.updated_at).format("DD/MM/YYYY HH:mm")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="h-[10rem]  p-3 text-sm text-center text-gray-400"
                  colSpan={6}
                >
                  No logs found for this bot.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="items-center justify-center mt-4 md:mt-6 flex">
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </div>
      {/* <div className="flex items-center mt-6 text-sm text-[#667085] gap-4">
        <a
          onClick={() => changePage(page - 1)}
          disabled={page === 1}
          className="!disabled:opacity-50 cursor-pointer"
        >
          <span className="font-medium text-[#101828]">&lt;</span> Previous
        </a>
        <div className="space-x-2">
          {[...Array(totalPages)].map((_, i) => (
            <a
              key={i}
              onClick={() => changePage(i + 1)}
              className={`p-4 rounded-md cursor-pointer ${
                page === i + 1
                  ? "bg-[#F0F0FF] text-[#7f56d9] font-semibold"
                  : "hover:bg-[#f2f4f7]"
              }`}
            >
              {i + 1}
            </a>
          ))}
        </div>
        <a
          onClick={() => changePage(page + 1)}
          disabled={page === totalPages}
          className="disabled:opacity-50 cursor-pointer"
        >
          Next <span className="font-medium text-[#101828]">&gt;</span>
        </a>
      </div> */}
    </div>
  );
};
